import { render } from "./PedigreeView.vue?vue&type=template&id=59859d51&scoped=true&ts=true"
import script from "./PedigreeView.vue?vue&type=script&lang=ts"
export * from "./PedigreeView.vue?vue&type=script&lang=ts"

import "./PedigreeView.vue?vue&type=style&index=0&id=59859d51&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59859d51"]])

export default __exports__